<template>
  <section id="kuratorium">
    <h1 class="no-pad" v-html="subpages.title"></h1>
    <curator :post="subpage" v-for="subpage in subpages.children" :key="subpage.uid">
    </curator>
  </section>
</template>

<script>
import Curator from '../components/Curator.vue'

export default {
  name: 'curators',
  components: {
    Curator
  },
  computed: {
    subpages () {
      return this.$store.getters.getPageByUID('kuratorium')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
</style>
